"use client";

import { type ReactNode, useEffect, useRef, useState } from "react";
import { cn, getCSSVar } from "../..";

interface StickyProps {
	children: ReactNode;
	className?: string;
}

export function Sticky({ children, className }: StickyProps) {
	const ref = useRef<HTMLDivElement>(null);
	const [isSticky, setIsSticky] = useState<boolean>(false);

	useEffect(() => {
		const element = ref.current;
		const headerY = getCSSVar("--header-y");

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry) {
					setIsSticky(entry.intersectionRatio < 1);
				}
			},
			{
				threshold: [1],
				rootMargin: `-${headerY}px 0px 0px 0px`,
			},
		);

		if (element) observer.observe(element);

		return () => {
			if (element) observer.unobserve(element);
		};
	}, []);

	return (
		<div
			ref={ref}
			className={cn(
				"sticky top-[calc(var(--header-y)-1px)] z-7 motion-safe:transition-shadow",
				{ shadow: isSticky },
				className,
			)}
		>
			{children}
		</div>
	);
}
